export default {
      id: "list_style_cards-usage",
      viewBox: "0 0 30 23.6",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#list_style_cards-usage",
      toString: function () {
        return this.url;
      }
    }